import { Tooltip } from '@ds';
import { MdInfoOutline } from 'react-icons/md';
import type { ReactNode } from 'react';

type ActionHintIconProps = {
  show?: boolean;
  message: string;
  size?: number;
  className?: string;
  ariaLabel?: string;
  icon?: ReactNode;
};

export const ActionHintIcon = ({
  show = true,
  message,
  size = 18,
  className,
  ariaLabel,
  icon,
}: ActionHintIconProps) => {
  if (!show) return null;

  return (
    <Tooltip content={message}>
      <span aria-label={ariaLabel} className={className}>
        {icon ?? <MdInfoOutline size={size} />}
      </span>
    </Tooltip>
  );
};
